import { Select } from 'antd';
import { ArticleChannelDto } from 'Api/Features/Articles/Dtos/ArticleChannelDto';
import React from 'react';
import { useTranslation } from 'react-i18next';
import './index.less';

interface ChannelSelectProps {
    value?: ArticleChannelDto;
    onChange: (value: ArticleChannelDto) => void;
    placeholder?: string;
    disabled?: boolean;
    allowClear?: boolean;
    includeAllOption?: boolean;
}

const ChannelSelect: React.FC<ChannelSelectProps> = ({
    value,
    onChange,
    placeholder,
    disabled = false,
    allowClear = false,
    includeAllOption = false,
}) => {
    const { t } = useTranslation();

    return (
        <Select
            className="ChannelSelect"
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            disabled={disabled}
            allowClear={allowClear}
            options={Object.values(ArticleChannelDto)
                .filter((x) => includeAllOption || x !== ArticleChannelDto.All)
                .map((channel) => ({
                    value: channel,
                    label: t(`article_channel_${channel}`),
                }))}
        />
    );
};

export default ChannelSelect;
